import { styled, ToggleButtonGroup, toggleButtonGroupClasses } from '@mui/material';

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    marginRight: theme.spacing(3),
    [`& .${toggleButtonGroupClasses.grouped}`]: {
        margin: theme.spacing(0, 1),
        padding: theme.spacing(0.5, 1.5),
        border: 0,
        borderRadius: theme.shape.borderRadius,
        [`&.${toggleButtonGroupClasses.disabled}`]: {
            border: 0
        }
    },
    [`& .${toggleButtonGroupClasses.middleButton},& .${toggleButtonGroupClasses.lastButton}`]: {
        marginLeft: -1,
        borderLeft: '1px solid transparent'
    }
}));
